import {
  LISTAR_AGENDAMENTOS,
  SELECIONAR_AGENDAMENTO,
  LISTAR_ROTAS,
  GET_ALL_OPERADORES,
  LISTAR_RAMAIS,
  GET_SPECIFIC_OPERADOR,
  GET_ALL_DEPARTAMENTS,
  GET_SPECIFIC_DEPARTAMENT,
  LISTAR_GRUPOS_DE_ROTAS
} from './mutation-types'

export default {
  [LISTAR_AGENDAMENTOS]: (state, agendamentos) => {
    state.agendamentos = agendamentos
  },
  [SELECIONAR_AGENDAMENTO]: (state, agendamento) => {
    state.agendamentoSelecionado = agendamento
  },
  [LISTAR_ROTAS]: (state, rotas) => {
    state.rotas = rotas
  },
  [GET_ALL_OPERADORES]: (state, operadores) => {
    state.operadores = operadores
  },
  [LISTAR_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
  [GET_SPECIFIC_OPERADOR]: (state, operador) => {
    state.operador = operador
  },
  [GET_ALL_DEPARTAMENTS]: (state, departamentos) => {
    state.departamentos = departamentos
  },
  [GET_SPECIFIC_DEPARTAMENT]: (state, departamento) => {
    state.departamento = departamento
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  }
}
